export const DASHBOARD_FILTER_FORM_MAPBOX = 'dashboardFilterMapbox';
